/**
 * MODULE: domain/pages/frontend/utils/pageBrainActivityScope.ts
 * PURPOSE: Build CRM link scope for cross-source page activity timeline API.
 * PUBLIC_API: pageBrainActivityScopeKey, pageBrainActivityScopeFromPage
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 45 / 150 lines
 * RECENT: 2026-05-25 [2.2.1196] — contact and company merge on by-page activity.
 */

import type { Page } from '../../contracts/pages.types';

export type PageBrainActivityScope = {
  dealId?: string;
  contactId?: string;
  companyId?: string;
};

export function pageBrainActivityScopeFromPage(
  page: Pick<Page, 'linked_deal_id' | 'linked_contact_id' | 'linked_company_id'>,
): PageBrainActivityScope {
  const dealId = (page.linked_deal_id || '').trim();
  const contactId = (page.linked_contact_id || '').trim();
  const companyId = (page.linked_company_id || '').trim();
  return {
    dealId: dealId || undefined,
    contactId: contactId || undefined,
    companyId: companyId || undefined,
  };
}

/** Stable react-query key segment for brain activity fetches. */
export function pageBrainActivityScopeKey(scope: PageBrainActivityScope = {}): string {
  const parts = [scope.dealId, scope.contactId, scope.companyId].filter(Boolean);
  return parts.join('|');
}
